<template>
    <div class="about-ep">
        <h3 class="indent">Заготовки – леене</h3>
        <p class="indent">Заготовките, които се използват в пресовото производство в Алкомет се произвеждат от собствената леярна на компанията, като използва една от най-модерните технологии, които могат да се срещнат на пазара - Wagstaff Hot Top Billet Casting System. Линията е предназначена за производство на „меки сплави“ покривайки сериите 1ххх и 6ххх. Химичният състав е гарантиран съгласно международните стандарти или клиентска спецификация.</p>
        <div class="about-ep-table">
          <div class="about-ep-table-row">
            <span>Размер на заготовката:</span>
            <span>4", 6", 7", 8"</span>
          </div>
          <div class="about-ep-table-row">
            <span>Годишен капацитет:</span>
            <span>36000 тона</span>
          </div>
        </div>
        <img class="about-ep-img" src="/static/img/about/ep/1.jpg" alt="Пресоване">
        <h3 class="indent">Пресоване</h3>
        <p class="indent">В пресов цех функционират 5 преси от 600 до 2500 тона с общ производствен капацитет от 36 000 тона на година.  Основният фокус е върху меките сплави за ABC сектора (архитектура, строителство и конструкции), реклама, транспорт и машиностроене. Последното въведение в пресовото производство е пускането в експоатация на последно поколение 25MN HybrEx преса, която позволява на компанията да произвежда профили с описана окръжност до 310мм и дебелина на стената до 0,8мм.</p>
        <div class="about-ep-table">
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Мощност <br/>на преса</span>
            <span class="about-ep-table-fifth">600</span>
            <span class="about-ep-table-fifth">1300</span>
            <span class="about-ep-table-fifth">1800</span>
            <span class="about-ep-table-fifth">2000</span>
            <span class="about-ep-table-fifth">2500</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth"></span>
            <span class="about-ep-table-fifth">4"</span>
            <span class="about-ep-table-fifth">6"</span>
            <span class="about-ep-table-fifth">7"</span>
            <span class="about-ep-table-fifth">8"</span>
            <span class="about-ep-table-fifth">8"</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Сплав</span>
            <span class="about-ep-table-fifth">6060,<br>6063</span>
            <span class="about-ep-table-fifth">1200,<br>6060,<br>6063,<br>6005</span>
            <span class="about-ep-table-fifth">6060,<br>6063,<br>6005</span>
            <span class="about-ep-table-fifth">6060,<br>6063,<br>6005,<br>6082</span>
            <span class="about-ep-table-fifth">6060,<br>6063,<br>6005,<br>6082</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Плътни<br>профили</span>
            <span class="about-ep-table-fifth">МАКС.<br> 90</span>
            <span class="about-ep-table-fifth">МАКС.<br> 150</span>
            <span class="about-ep-table-fifth">МАКС.<br> 170</span>
            <span class="about-ep-table-fifth">МАКС.<br> 200</span>
            <span class="about-ep-table-fifth">МАКС.<br> 300</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Кухи<br>профили </span>
            <span class="about-ep-table-fifth">МАКС.<br> 70</span>
            <span class="about-ep-table-fifth">МАКС.<br> 130</span>
            <span class="about-ep-table-fifth">МАКС.<br> 150</span>
            <span class="about-ep-table-fifth">МАКС.<br> 180</span>
            <span class="about-ep-table-fifth">МАКС.<br> 280</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Тегло<br>(kg/m)</span>
            <span class="about-ep-table-fifth">0.05-0.7</span>
            <span class="about-ep-table-fifth">0.1-1.8</span>
            <span class="about-ep-table-fifth">0.2-2.3</span>
            <span class="about-ep-table-fifth">0.35-9</span>
            <span class="about-ep-table-fifth">0.5-10</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Дължина на <br/>пресоване<br/>(mm)</span>
            <span class="about-ep-table-fifth">1000-<br>7000</span>
            <span class="about-ep-table-fifth">1000-<br>8000</span>
            <span class="about-ep-table-fifth">1000-<br>8000</span>
            <span class="about-ep-table-fifth">1000-<br>11500</span>
            <span class="about-ep-table-fifth">1500-<br>8000</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Дебелина <br>на стената<br>(mm)</span>
            <span class="about-ep-table-fifth">MIN.<br>0.8</span>
            <span class="about-ep-table-fifth">MIN.<br>1.0</span>
            <span class="about-ep-table-fifth">MIN.<br>1.0</span>
            <span class="about-ep-table-fifth">MIN.<br>1.2</span>
            <span class="about-ep-table-fifth">MIN.<br>1.2</span>
          </div>
        </div>
        <img class="about-ep-img" src="/static/img/about/ep/2.jpg" alt="Rolling">

<!--
        <h3 class="indent">Surface Treatment</h3>
        <p class="indent">For products demanding decorative appearance or improved corrosion resistance Alcomet can offer a wide range of finishing services on its in-house anodizing and powder coating lines. Available anodizing colours are silver, gold, bronze and black in standard mat finish or with additional pretreatment, such as sandblasting or brushing. Powder coating, on the other hand, offers an infinite variety of colours based on RAL standard or customer’s specifications.</p>
        <p class="indent">Both lines operate in full compliance with ISO14001.</p>
        <p><span class="strong">Powder coating</span> - Powder coating is a type of surface treatment providing a decorative finish to aluminium products. Its main benefits are good resistance to high impact abrasion, flexibility, high UV radiation and corrosion resistance.</p>
        <div class="about-ep-table">
          <div class="about-ep-table-row">
            <span>Maximum length:</span>
            <span>6500 mm</span>
          </div>
          <div class="about-ep-table-row">
            <span>Coating thickness</span>
            <span>60-200 microns</span>
          </div>
          <div class="about-ep-table-row">
            <span>Powder coating capacity</span>
            <span>2500 tons per year</span>
          </div>
        </div>
        <img class="about-ep-img" src="/static/img/about/ep/3.jpg" alt="Rolling">
        <p class="indent"><span class="strong">Anodizing</span> - Electrochemical anodizing is the process of covering the surface of the product with a transparent oxide layer. This process is carried out on a computer-controlled automatic line in four distinctive stages: pre-treatment with satin finishing, anodizing, colouring and hot sealing. Key features of the anodized products are increased hardness, attractive appearance and corrosion resistance. Electrochemical anodizing is the process of covering the surface of the product with a transparent oxide layer. This process is carried out on a computer-controlled automatic line in four distinctive stages: pre-treatment with satin finishing, anodizing, colouring and hot sealing. Key features of the anodized products are increased hardness, attractive appearance and corrosion resistance.</p>
        <img class="about-ep-img" src="/static/img/about/ep/31.jpg" alt="Rolling">
        <div class="about-ep-table">
          <div class="about-ep-table-row">
            <span>Pre-treatment:</span>
            <span>E6 (matt finish)</span>
          </div>
          <div class="about-ep-table-row">
            <span>Max. length</span>
            <span>6500 mm</span>
          </div>
          <div class="about-ep-table-row">
            <span>Coating thickness</span>
            <span>10-25 microns</span>
          </div>
          <div class="about-ep-table-row">
            <span>Anodizing capacity</span>
            <span>2500 tons per year</span>
          </div>
        </div>
        <div class="colors">
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(174,175,176,1)'}"></div>
                <span>Natural</span>
                <span>(C0)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(184,159,94,1)'}"></div>
                <span>Champagne</span>
                <span>(C2)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(192,135,56,1)'}"></div>
                <span>Gold</span>
                <span>(C3)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(151,143,118,1)'}"></div>
                <span>Light bronze</span>
                <span>(C32)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(117,102,74,1)'}"></div>
                <span>Dark bronze</span>
                <span>(C33)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(0,0,0,1)'}"></div>
                <span>Black</span>
                <span>(C35)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(150,150,150,1)'}"></div>
                <span>Sandblasting</span>
                <span>(E6/C0 SB)</span>
            </div>
        </div>
        <h3 class="indent">Fabrication</h3>
        <p class="indent">Strong demand for profiles with additional fabrication has urged Alcomet to invest in own fabrication facilities, such as CNC-machining and precision cutting. The automatic high precision saw is capable of cutting profiles to a length of min. 20 mm with a tolerance of +/-0.2 mm while the 3-axis CNC center offers a selection of drilling, milling and tapping operations on up to three sides of the profile. Positive market response means the company will continue to expand its fabrication facilities in the future offering more sophisticated and complex operations to its customers.</p>
        <div class="about-ep-table">
          <div class="about-ep-table-row about-ep-table-row-title">
            <span>Precision sawing:</span>
          </div>
          <div class="about-ep-table-row">
            <span>min. length</span>
            <span>20 mm</span>
          </div>
          <div class="about-ep-table-row">
            <span>max. length</span>
            <span>8000 mm</span>
          </div>
          <div class="about-ep-table-row">
            <span>Cutting at</span>
            <span>90 degrees</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-title">
            <span>45-degrees cut:</span>
          </div>
          <div class="about-ep-table-row">
            <span>min. length</span>
            <span>200 mm</span>
          </div>
          <div class="about-ep-table-row">
            <span>max. length</span>
            <span>2800 mm</span>
          </div>
          <div class="about-ep-table-row">
            <span>Tolerance:</span>
            <span>+/-0.5 mm</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-title">
            <span>Max. profile dimensions:</span>
          </div>
          <div class="about-ep-table-row">
            <span>height</span>
            <span>120 mm</span>
          </div>
          <div class="about-ep-table-row">
            <span>width</span>
            <span>95 mm</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-title">
            <span>CNC-machining:</span>
          </div>
          <div class="about-ep-table-row">
            <span>min. length</span>
            <span>100 mm</span>
          </div>
          <div class="about-ep-table-row">
            <span>max. length</span>
            <span>6500 mm</span>
          </div>
          <div class="about-ep-table-row">
            <span>3-axis movement</span>
            <span>Yes</span>
          </div>
        </div>
        <img class="about-ep-img" src="/static/img/about/ep/4.jpg" alt="Rolling">
-->


        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-ep {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.about-ep > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-ep > h3 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-ep-table {
  margin: 15px 0;
  width: 60%;
}
.about-ep-table-row {
  align-items: center;
  background-color: #eef2f8;
  border-radius: 6px;
  display: flex;
  height: 50px;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 20px;
  width: 100%;
}
.about-ep-table-row-title {
  background-color: transparent;
}
.about-ep-table-row-fifth {
  height: initial;
  min-height: 50px;
  padding: 15px 20px;
}
.about-ep-table-row > span,
.about-ep-table-fifth {
  font-weight: 700;
  font-size: 16px;
  color: #1a437c;
}
.about-ep-table-row-title > span {
  font-weight: 400;
}
.about-ep-table-fifth {
  display: inline-flex;
  justify-content: center;
  text-align: center;
  width: 20%;
}
.about-ep-img {
  border-radius: 5px;
  height: auto;
  margin: 20px auto;
  min-height: 1px;
  width: 80%;
}
.colors {
  display: flex;
  margin: 15px 0;
}
.color {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.color-square {
  border-radius: 6px;
  height: 8vw;
  margin: 10px;
  width: 8vw;
}
@media screen and (max-width: 1000px) {
  .about-ep p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-ep-table,
  .about-ep > h3 {
    width: 100%;
    padding: 0 30px;
  }
  .about-ep-img {
    width: calc(100% - 60px);
  }
  .color > span {
    font-size: 12px;
  }
}
@media screen and (max-width: 600px) {
  .about-ep-table-row > span,
  .about-ep-table-fifth {
    font-size: 12px;
  }
  .about-ep-table-row-fifth {
    padding: 15px;
  }
  .colors {
    flex-direction: column;
    padding: 0 30px;
    width: 100%;
  }
  .color {
    flex-direction: row;
  }
  .color-square {
    height: 10vw;
    width: 10vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/ExtrusionPlant.vue